var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseStatic',{attrs:{"static-page":_vm.staticPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }